import { keepPreviousData, useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { AgentApiAnalysisSalesDetails } from '@/types/serializers';
import type { SalesQueryParams } from './useFetchAnalysisSales';

export interface SalesDetailsQueryParams extends SalesQueryParams {
  page: number;
}

/**
 * 売上明細テーブル（月別グループ + 日次明細）をページネーション付きで取得するフック。
 */
export default function useFetchAnalysisSalesDetails(
  params: SalesDetailsQueryParams,
  options?: { enabled?: boolean }
) {
  const query = qs.stringify(params, { arrayFormat: 'brackets' });

  return useQuery<AgentApiAnalysisSalesDetails>({
    queryKey: ['/agent/api/analysis/sales/details', query],
    queryFn: async () => {
      const response = await fetch(`/agent/api/analysis/sales/details.json?${query}`);
      if (!response.ok) {
        throw new Error('売上明細データの取得に失敗しました');
      }
      return response.json() as Promise<AgentApiAnalysisSalesDetails>;
    },
    placeholderData: keepPreviousData,
    enabled: options?.enabled ?? true,
  });
}
